import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({ providedIn: 'root' })
export class FileSaverService {
  saveAs(data: Blob | string, filename?: string): void {
    saveAs(data, filename);
  }
}
